import { getFileRequest, getRequest, patchRequest, postRequest } from '../request/request.service';
import { OUTBOUND_API } from './outbound-calls.constants';
import {
  CampaignAction,
  CampaignActionResult,
  CampaignEntriesParams,
  CampaignEntriesResponse,
  CampaignImportReport,
  OutboundCampaign,
  OutboundCampaignPayload,
  OutboundCampaignsResponse,
} from './campaigns.service.types';

const CAMPAIGNS_URL = `${OUTBOUND_API}/campaigns`;

/** Newest first, not paginated. */
export function getOutboundCampaigns(companyId: number) {
  return getRequest<OutboundCampaignsResponse>(CAMPAIGNS_URL, {
    params: { company_id: companyId },
  });
}

export function getOutboundCampaign(id: number) {
  return getRequest<OutboundCampaign>(`${CAMPAIGNS_URL}/${id}`);
}

export function createOutboundCampaign(companyId: number, payload: OutboundCampaignPayload) {
  return postRequest<OutboundCampaign>(CAMPAIGNS_URL, {
    params: { company_id: companyId },
    data: payload,
  });
}

export function updateOutboundCampaign(id: number, payload: OutboundCampaignPayload) {
  return patchRequest<OutboundCampaign>(`${CAMPAIGNS_URL}/${id}`, { data: payload });
}

/** A transition the campaign refuses is a 422 `{errors, code: 'campaign_refused'}`. */
export function runCampaignAction(id: number, action: CampaignAction) {
  return postRequest<CampaignActionResult>(`${CAMPAIGNS_URL}/${id}/${action}`);
}

export function getCampaignEntries(id: number, params: CampaignEntriesParams) {
  return getRequest<CampaignEntriesResponse>(`${CAMPAIGNS_URL}/${id}/entries`, { params });
}

/** Every row the table's filters match, not one page of them. */
export function exportCampaignEntries(id: number, { status, query }: CampaignEntriesParams) {
  return getFileRequest(`${CAMPAIGNS_URL}/${id}/entries`, `campaign-${id}.csv`, {
    params: { status, query, format: 'csv' },
  });
}

/** `dryRun` saves nothing and returns only the report. */
export function importCampaignList(id: number, file: File, dryRun: boolean) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('dry_run', String(dryRun));

  return postRequest<CampaignImportReport>(`${CAMPAIGNS_URL}/${id}/import`, {
    data: formData,
  });
}

export function getCampaignImportTemplate() {
  return getFileRequest(`${CAMPAIGNS_URL}/import_template`, 'campaign-leads-template.csv');
}
